import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

function Datenschutz() {
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            <img src="/images/logo.png" alt="F&F AI Automation" className="nav-logo-img" />
          </Link>
          <Link to="/" className="back-link">Zurück zur Startseite</Link>
        </div>
      </nav>

      <main className="legal-content">
        <div className="legal-container">
          <h1>Datenschutzerklärung</h1>

          <div className="legal-section">
            <h2>1. Datenschutz auf einen Blick</h2>
            <p>
              Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Verantwortliche Stelle</h2>
            <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
            <p>
              F&amp;F AI Automation Services &amp; Products UG (haftungsbeschränkt)<br />
              Wannenstr. 14<br />
              74842 Billigheim<br />
              Deutschland
            </p>
            <p>
              Vertreten durch: Robin Fichter, Gabriel Frank<br />
              Kontakt: <a href="mailto:info@ff-ai-automation.de">info@ff-ai-automation.de</a>
            </p>
          </div>

          <div className="legal-section">
            <h2>3. Hosting durch IONOS</h2>
            <p>
              Wir hosten unsere Website bei der IONOS SE, Elgendorfer Str. 57, 56410 Montabaur. Beim Besuch unserer Website erfasst IONOS automatisch Server-Log-Dateien (u.a. IP-Adresse, Browsertyp, Referrer-URL).
            </p>
            <p>
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren und stabilen Betrieb).
            </p>
            <p>
              <strong>Auftragsverarbeitung:</strong> Wir haben mit IONOS einen Vertrag über Auftragsverarbeitung (AVV) gemäß Art. 28 DSGVO geschlossen.
            </p>
          </div>

          <div className="legal-section">
            <h2>4. Analyse-Tools und Tracking: Google Analytics 4 (GA4)</h2>
            <p>
              Diese Website nutzt Google Analytics 4, einen Webanalysedienst der Google Ireland Limited („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
            </p>
            <p>
              <strong>Einwilligung (Consent):</strong> Wir nutzen Google Analytics nur, wenn Sie uns hierzu über unseren Consent-Banner Ihre ausdrückliche Zustimmung erteilt haben.
            </p>
            <p>
              <strong>Rechtsgrundlage:</strong> Die Datenverarbeitung erfolgt ausschließlich auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
            </p>
            <p>
              <strong>Mess-ID:</strong> G-W3RS2GXEHK.
            </p>
            <p>
              <strong>IP-Anonymisierung:</strong> Bei GA4 ist die Anonymisierung der IP-Adresse standardmäßig aktiviert und technisch nicht deaktivierbar.
            </p>
            <p>
              <strong>Widerruf:</strong> Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie{' '}
              <button
                className="cookie-revoke-link"
                onClick={() => window.dispatchEvent(new Event('showCookieBanner'))}
              >
                Ihre Cookie-Einstellungen anpassen
              </button>
              {' '}oder die Speicherung von Cookies in Ihrem Browser deaktivieren.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. Datenerfassung über das Kontaktformular</h2>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben (insbesondere E-Mail-Adresse) gespeichert.
            </p>
            <p>
              <strong>Zweck:</strong> Bearbeitung der Anfrage sowie Direktwerbung/Marketingzwecke.
            </p>
            <p>
              <strong>Rechtsgrundlage:</strong> Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO, erteilt durch das Absenden des Formulars.
            </p>
            <p>
              <strong>Speicherdauer:</strong> Die Daten werden gelöscht, sobald sie für die Zweckerreichung nicht mehr erforderlich sind oder Sie Ihre Einwilligung widerrufen.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Datensicherheit</h2>
            <p>
              Zur Sicherung Ihrer Daten nutzen wir eine TLS-Verschlüsselung (HTTPS). Dies verhindert, dass Daten, die Sie an uns übermitteln (z.B. via Kontaktformular), von Dritten mitgelesen werden können.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Ihre Rechte</h2>
            <p>Sie haben das Recht auf:</p>
            <ul>
              <li>Auskunft über Ihre bei uns gespeicherten Daten.</li>
              <li>Berichtigung unrichtiger Daten.</li>
              <li>Löschung Ihrer Daten („Recht auf Vergessenwerden").</li>
              <li>Einschränkung der Verarbeitung und Datenübertragbarkeit.</li>
              <li>Widerspruch gegen die Verarbeitung zu Werbezwecken.</li>
              <li>Beschwerde bei der zuständigen Aufsichtsbehörde (LfDI Baden-Württemberg).</li>
            </ul>
          </div>
        </div>
      </main>

      <footer className="legal-footer">
        <p>© {new Date().getFullYear()} F&F AI Automation</p>
      </footer>
    </div>
  );
}

export default Datenschutz;
